/**
 * Jertscript Keywords Mapping
 *
 * Maps French keywords to their token types.
 * "Honestly, TypeScript could use more croissants." 🥐
 */

import { TokenType } from './tokens';

/**
 * Map of Jertscript keywords to their token types
 */
export const KEYWORDS: Record<string, TokenType> = {
  // Variables
  'croissant': TokenType.CROISSANT,     // const
  'baguette': TokenType.BAGUETTE,       // let

  // Literals
  'oui': TokenType.OUI,                 // true
  'non': TokenType.NON,                 // false
  'rien': TokenType.RIEN,               // null

  // Functions
  'fonction': TokenType.FONCTION,       // function
  'retourner': TokenType.RETOURNER,     // return

  // Control Flow
  'franchement': TokenType.FRANCHEMENT, // if
  'sinon': TokenType.SINON,             // else

  // Loops
  'pendant': TokenType.PENDANT,         // while
  'pour': TokenType.POUR,               // for
  'casser': TokenType.CASSER,           // break
  'continuer': TokenType.CONTINUER,     // continue

  // Error Handling
  'malheureusement': TokenType.MALHEUREUSEMENT, // try
  'merde': TokenType.MERDE,             // catch
  'quandmeme': TokenType.QUANDMEME,     // finally
  'lancer': TokenType.LANCER,           // throw

  // OOP
  'classe': TokenType.CLASSE,           // class
  'nouveau': TokenType.NOUVEAU,         // new
  'ceci': TokenType.CECI,               // this

  // Async
  'attendre': TokenType.ATTENDRE,       // await
  'asynchrone': TokenType.ASYNCHRONE,   // async

  // Modules
  'importer': TokenType.IMPORTER,       // import
  'exporter': TokenType.EXPORTER,       // export
  'de': TokenType.DE,                   // from

  // Logical Operators (as keywords)
  'et': TokenType.ET,                   // &&
  'ou': TokenType.OU,                   // ||
  'pas': TokenType.PAS,                 // !
  'est': TokenType.EST,                 // ===
  'nest_pas': TokenType.NEST_PAS,       // !==
};

/**
 * Looks up an identifier to see if it's a reserved keyword.
 * Returns the keyword's token type if found, or IDENTIFIER if not.
 *
 * @param text - The identifier text to look up
 * @returns The TokenType for the keyword, or IDENTIFIER if not a keyword
 */
export function lookupKeyword(text: string): TokenType {
  const keyword = KEYWORDS[text];
  if (keyword !== undefined) {
    return keyword;
  }
  return TokenType.IDENTIFIER;
}
